import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./Components/ErrorBoundary/ErrorBoundary";
import LogRocket from "logrocket";
import * as Sentry from "@sentry/react";

if (
  window.location.hostname !== "localhost" &&
  window.location.hostname !== "127.0.0.1" &&
  process.env.REACT_APP_SENTRY_KEY
) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_KEY,
    sendDefaultPii: true,
    integrations: [Sentry.replayIntegration()],
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.REACT_APP_STAGING
  });
}

ReactDOM.render(
  <ErrorBoundary
    onClick={() => {
      localStorage.clear();
      window.location.reload();
    }}
    handleComponentDidCatch={(error, errorInfo) => {
      // window.gtag("event", "exception", {
      //   code: error.code,
      //   userType: this.props.userType,
      //   message: error.message,
      //   fatal: true
      // });
      LogRocket.captureMessage(error.message, {
        tags: {
          userType: "public",
        },
        extra: {
          fatal: true,
          code: error.code,
        },
      });
    }}
  >
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  </ErrorBoundary>,
  document.getElementById("root")
);
